import React from 'react';
import { Dialog } from 'primereact/dialog';
import { useHistory, useLocation } from 'react-router-dom';
import * as qs from 'query-string';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'primereact/button';

const messages = defineMessages({
  beforeYouChange: {
    id: 'change-subscription.before-you-change',
    defaultMessage: 'Before you change your NoLimit subscription',
  },
  firstParagraph: {
    id: 'change-subscription.before-you-change.first-paragraph',
    defaultMessage:
      'If you change your NoLimit subscription, you will have a store credit equal to the unused portion of your present subscription. For example, if you paid $100 for your present subscription and change it exactly halfway into the prepaid subscription period, the unused portion of your present subscription is $50. Thus, you will have a store credit of $50.',
  },
  secondParagraph: {
    id: 'change-subscription.before-you-change.second-paragraph',
    defaultMessage:
      'The store credit is deducted in your new NoLimit subscription. For example, if your new subscription is $40, your first payment is fully covered by the store credit while your next payment will be $30 as it is only partially covered by the remaining $10 store credit. After that, your will pay $40 for your new NoLimit subscription. If you have multiple NoLimit subscriptions, your store credit is applied to any of these on a “first come, first served” basis.',
  },
  thirdParagraph: {
    id: 'change-subscription.before-you-change.third-paragraph',
    defaultMessage: 'Store credit cannot be used for any other purpose or cashed out.',
  },
  iAgree: {
    id: 'change-subscription.i-agree',
    defaultMessage: 'I agree',
  },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
});

const ChangeSubscriptionNotice = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const { formatMessage } = useIntl();
  const { clientId, showStoreCreditExplanation } = qs.parse(search);

  const hideDialog = () => {
    if (clientId) {
      history.push(`${pathname}?clientId=${clientId}`);
    } else {
      history.push(pathname);
    }
  };

  const dialogVisible = !!showStoreCreditExplanation === true;

  return (
    <Dialog
      visible={dialogVisible}
      header={formatMessage(messages.beforeYouChange)}
      onHide={hideDialog}
      closable={false}
    >
      <p>{formatMessage(messages.firstParagraph)}</p>
      <p>{formatMessage(messages.secondParagraph)}</p>
      <p>{formatMessage(messages.thirdParagraph)}</p>
      <div className="flex-center">
        <Button
          type="button"
          className="p-button-primary"
          onClick={hideDialog}
          label={formatMessage(messages.iAgree)}
        />
        <Button
          type="button"
          className="p-button-danger"
          onClick={() => history.goBack()}
          label={formatMessage(messages.cancel)}
        />
      </div>
    </Dialog>
  );
};

export default ChangeSubscriptionNotice;
